<app-select
  [label]="'Setor'"
  [tooltipText]="tooltip"
  [placeholder]="'Sem setor'"
  [options]="options()"
  [loading]="loading()"
  [formGroup]="form()"
  [controlName]="controlName()"
  [emptyFilterMessage]="
    'Nenhum setor com esse nome. Peça a um administrador da Legatus para cadastrar.'
  " />
@if (loadFailed()) {
  <small class="p-error">
    Não foi possível carregar a lista de setores. O setor atual é mantido ao salvar; recarregue a
    página para escolher outro.
  </small>
}
